// extracted by mini-css-extract-plugin
export default {"item":"Settings_item__Fhsf-","secondPage":"Settings_secondPage__A6vJv","active":"Settings_active__Oddne"};